/* global modForm */
import { appendFormInput, saveUserInfoToCookie, populateFormWithZipData, populateLocationFieldsDynamically } from '../../../helpers';
import { isZipCodeValid } from '../../../validators';
/**
 * Pre-populate any fields with matching query string keys with their values.
 * Info on our Pre-Population Rules:
 * https://confluence.modernize.com/display/ENG/Microsite+Forms%3A+Pre-Population+Rules
 */
export function prepopFormFromURL() {
	Object.keys(modForm.opts.getVars).forEach(function(key) {
		if (!modForm.opts.ignoreQueryParams.includes(key)) {
			appendFormInput(key, modForm.opts.getVars[key]);
		}
		if ('zip' === key) {
			appendFormInput('zip1', modForm.opts.getVars[key]);
			appendFormInput('inertZip', modForm.opts.getVars[key]);
		}

		if (modForm.opts.prepopulateUserInfo) {
			saveUserInfoToCookie(key, modForm.opts.getVars[key]);
		}
	});

	// Process zip
	if ('undefined' !== typeof modForm.opts.getVars.zip) {
		// TODO: Remove
		if (!modForm.opts.prepopulateUserInfo) {
			isZipCodeValid(modForm.opts.getVars.zip, function(response) {
				// If success..
				if (response.success) {
					// Populate city & state
					if (response.data) {
						populateFormWithZipData(response.data);
						populateLocationFieldsDynamically(response.data);

						// Fire callback
						if ('function' === typeof modForm.opts.zipCodeValidated) {
							modForm.opts.zipCodeValidated(response.data);
						}
					}
				}
			});
		}
	}
}
